export default __webpack_public_path__ + "static/media/br-speed.c0f3e39d.svg";